
import { Component, Vue, Prop } from 'vue-property-decorator';
import hexToRgba from 'hex-to-rgba';

@Component
export default class BlurredImage extends Vue {
  @Prop() isDark!: boolean;
  @Prop({ default: '100%' }) width!: number;
  @Prop({ default: '100%' }) height!: number;
  @Prop() url!: string;
  @Prop() primaryColor!: string;
  @Prop({ default: 0.6 }) opacity!: number;

  get color(): string {
    if (this.primaryColor) {
      return this.primaryColor;
    }

    return this.isDark ? '#000' : '#fff';
  }

  get overlayBackground(): string {
    return hexToRgba(this.color, this.opacity);
  }
}
